import React, { useEffect, useState } from "react";
import { Button, Form } from "react-bootstrap";
import Select from "react-select";
import "./Reproducibility_Form.css";
import { faCirclePlus } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  Create,
  GetAll,
} from "../../../../../../../../../src/features/admin/quality_management/process_requirement/repeatability/Slice";
import {
  allTestType,
  AllChemist,
  allSampleManagement,
  AllTestMethod,
} from "../../../../../../../../features/admin/common/Slice";
import { useDispatch, useSelector } from "react-redux";
import { Controller, useFieldArray, useForm } from "react-hook-form";

function Reproducibility_Form({ fetchCustomers, onProceed, selectionTypeId }) {
  const dispatch = useDispatch();
  const all_test_type = useSelector((state) => state.common.all_test_type);
  const all_chemist = useSelector((state) => state.common.all_chemist);

  useEffect(() => {
    dispatch(allTestType());
    dispatch(AllChemist());
  }, [dispatch]);

  const {
    control,
    handleSubmit,
    register,
    formState: { errors },
    reset,
  } = useForm({
    defaultValues: {
      observations: [{ value: "" }],
    },
  });

  const { fields, append, remove } = useFieldArray({
    control,
    name: "observations",
  });
  const onSubmit = async (formData) => {
    const payload = {
      test_method_id: formData.test_method_id,
      selection_type_id: selectionTypeId,
      test_type_id: formData.test_type_id,
      certified_value: formData.certified_value,
      average: formData.average,
      std_deviation: formData.std_deviation,
      rsd: formData.rsd,
      date: formData.date,
      remark: formData.remark,
      checked_by: formData.chemist_assigned_id,
      sample_id: formData.sample_management_id,
      observations: formData.observations.map((o) => o.value),
    };

    await dispatch(Create(payload));
    fetchCustomers();
    reset();
    onProceed();
  };

  const all_sample_management = useSelector(
    (state) => state.common.all_sample_management,
  );
  const all_test_method = useSelector((state) => state.common.all_test_method);
  useEffect(() => {
    dispatch(allSampleManagement());
    dispatch(AllTestMethod());
  }, [dispatch]);

  return (
    <section className="Legal_Entity_Form">
      <div className="white_container customer_section">
        <div className="row">
          {/* Test Type */}
          <div className="col-md-4">
            <Form.Group className="form_group">
              <Form.Label>Test Type</Form.Label>
              <Controller
                name="test_type_id"
                control={control}
                rules={{ required: "Test Type is required" }}
                render={({ field }) => (
                  <Select
                    options={all_test_type}
                    value={
                      all_test_type?.find((o) => o.value === field.value) ||
                      null
                    }
                    onChange={(e) => field.onChange(e?.value || null)}
                  />
                )}
              />
              {errors.test_type_id && (
                <Form.Text className="text-danger">
                  {errors.test_type_id.message}
                </Form.Text>
              )}
            </Form.Group>
          </div>

          <div className="col-md-4">
            <Form.Group className="form_group">
              <Form.Label>Sample ID</Form.Label>
              <Controller
                name="sample_management_id"
                control={control}
                rules={{ required: "Sample is required" }}
                render={({ field }) => (
                  <Select
                    options={all_sample_management}
                    value={
                      all_sample_management?.find(
                        (o) => o.value === field.value,
                      ) || null
                    }
                    onChange={(e) => field.onChange(e?.value || null)}
                  />
                )}
              />
              {errors.sample_management_id && (
                <Form.Text className="text-danger">
                  {errors.sample_management_id.message}
                </Form.Text>
              )}{" "}
            </Form.Group>
          </div>

          <div className="col-md-4">
            <Form.Group className="form_group">
              <Form.Label>Test Method</Form.Label>
              <Controller
                name="test_method_id"
                control={control}
                rules={{ required: "Test Method is required" }}
                render={({ field }) => (
                  <Select
                    options={all_test_method}
                    value={
                      all_test_method?.find((o) => o.value === field.value) ||
                      null
                    }
                    onChange={(e) => field.onChange(e?.value || null)}
                  />
                )}
              />
              {errors.test_method_id && (
                <small className="text-danger">
                  {errors.test_method_id.message}
                </small>
              )}
            </Form.Group>
          </div>

          {/* Certified Value */}
          <div className="col-md-4">
            <Form.Group className="form_group">
              <Form.Label>Certified Value</Form.Label>
              <Form.Control
                placeholder="Certified Value"
                {...register("certified_value", {
                  // required: "Certified value is required",
                })}
              />
              {errors.certified_value && (
                <Form.Text className="text-danger">
                  {errors.certified_value.message}
                </Form.Text>
              )}
            </Form.Group>
          </div>

          <div className="col-md-4">
            <Form.Group className="form_group">
              <Form.Label>Remark</Form.Label>
              <Form.Control
                placeholder="Enter Remark"
                {...register("remark", {
                  required: "Remark is required",
                })}
              />
              {errors.remark && (
                <Form.Text className="text-danger">
                  {errors.remark.message}
                </Form.Text>
              )}
            </Form.Group>
          </div>
        </div>

        {/* Observations */}
        <div className="inner_form_section_holder">
          <div className="">
            <div className="heading_add_text">
              <div>
                <Form.Group className="form_group">
                  <Form.Label>Observation</Form.Label>
                </Form.Group>
              </div>
              <div className="add_another_holder">
                <div>
                  <span onClick={() => append({ value: "" })}>
                    <FontAwesomeIcon icon={faCirclePlus} /> Add Another Day
                  </span>
                </div>
              </div>
            </div>

            <div className="row">
              {fields.map((field, index) => (
                <div key={field.id} className="col-xl-2 col-lg-4  col-md-4">
                  <div className="observation_box">
                    <div className="obs_label">
                      Day {String(index + 1).padStart(2, "0")}
                    </div>

                    <Form.Control
                      {...register(`observations.${index}.value`, {
                        required: "Observation is required",
                      })}
                      onKeyDown={(e) => {
                        // allow numbers
                        if (/[0-9]/.test(e.key)) return;

                        // allow one decimal point only
                        if (e.key === "." && !e.target.value.includes("."))
                          return;

                        // allow control keys
                        if (
                          [
                            "Backspace",
                            "Delete",
                            "ArrowLeft",
                            "ArrowRight",
                            "Tab",
                          ].includes(e.key)
                        )
                          return;

                        // block everything else
                        e.preventDefault();
                      }}
                    />
                    {errors.observations?.[index]?.value && (
                      <small className="text-danger">
                        {errors.observations[index].value.message}
                      </small>
                    )}
                    {fields.length > 1 && (
                      <button type="button" onClick={() => remove(index)}>
                        ❌
                      </button>
                    )}
                  </div>
                </div>
              ))}
            </div>
          </div>

          <div className="row mt-3">
            {/* Average */}
            <div className="col-md-4">
              <Form.Group className="form_group">
                <Form.Label>Date</Form.Label>
                <Form.Control
                  type="date"
                  placeholder="Enter Date"
                  {...register("date", {
                    required: "Date is required",
                    // validate: (value) => {
                    //   const year = value.split("-")[0];

                    //   if (year.length !== 4) {
                    //     return "Year must be exactly 4 digits";
                    //   }

                    //   const selectedDate = new Date(value);
                    //   const today = new Date();
                    //   today.setHours(0, 0, 0, 0);

                    //   if (selectedDate < today) {
                    //     return "Past dates are not allowed";
                    //   }

                    //   return true;
                    // },
                  })}
                  onChange={(e) => {
                    let value = e.target.value;
                    const parts = value.split("-");

                    if (parts[0] && parts[0].length > 4) {
                      parts[0] = parts[0].slice(0, 4);
                      e.target.value = parts.join("-");
                    }
                  }}
                />
                {errors.date && (
                  <Form.Text className="text-danger">
                    {errors.date.message}
                  </Form.Text>
                )}
              </Form.Group>
            </div>
            <div className="col-md-4">
              <Form.Group className="form_group">
                <Form.Label>Average</Form.Label>
                <Form.Control
                  placeholder="Average Value"
                  {...register("average", {
                    required: "Average is required",
                  })}
                />
                {errors.average && (
                  <Form.Text className="text-danger">
                    {errors.average.message}
                  </Form.Text>
                )}
              </Form.Group>
            </div>

            {/* Std Deviation */}
            <div className="col-md-4">
              <Form.Group className="form_group">
                <Form.Label>Std Deviation</Form.Label>
                <Form.Control
                  placeholder="Std Deviation"
                  {...register("std_deviation", {
                    required: "Std deviation is required",
                  })}
                />
                {errors.std_deviation && (
                  <Form.Text className="text-danger">
                    {errors.std_deviation.message}
                  </Form.Text>
                )}
              </Form.Group>
            </div>
          </div>

          <div className="row">
            {/* RSD */}
            <div className="col-md-4">
              <Form.Group className="form_group">
                <Form.Label>RSD</Form.Label>
                <Form.Control
                  placeholder="RSD"
                  {...register("rsd", {
                    required: "RSD is required",
                  })}
                />
                {errors.rsd && (
                  <Form.Text className="text-danger">
                    {errors.rsd.message}
                  </Form.Text>
                )}
              </Form.Group>
            </div>

            {/* Checked By */}
            <div className="col-md-4">
              <Form.Group className="form_group">
                <Form.Label>Checked By</Form.Label>
                <Controller
                  name="chemist_assigned_id"
                  control={control}
                  rules={{ required: "Test Type is required" }}
                  render={({ field }) => (
                    <Select
                      options={all_chemist}
                      value={
                        all_chemist?.find((o) => o.value === field.value) ||
                        null
                      }
                      onChange={(e) => field.onChange(e?.value || null)}
                    />
                  )}
                />
                {errors.chemist_assigned_id && (
                  <Form.Text className="text-danger">
                    {errors.chemist_assigned_id.message}
                  </Form.Text>
                )}
              </Form.Group>
            </div>
          </div>
        </div>
        {/* Footer Buttons */}
        <div className="permission_btn_holder">
          <Button className="permission_btn No_btn">Reset</Button>
          <Button
            className="permission_btn Yes_btn"
            onClick={handleSubmit(onSubmit)}
          >
            Save
          </Button>
        </div>
      </div>
    </section>
  );
}

export default Reproducibility_Form;
